import { createAction, props } from '@ngrx/store';

import { FaceDetectionResponse } from '../../responses/face-detection.response';
import { GetSnapshotResponse } from '../../responses/get-snapshot.response';

const faceDetectionActions = {
  compareFace: '[Face Detection] Compare Face',
  compareFaceSuccess: '[Face Detection] Compare Face Success',
  compareFaceFailure: '[Face Detection] Compare Face Failure',
  getUserSnapshot: '[Face Detection] Get User Snapshot',
  getUserSnapshotSuccess: '[Face Detection] Get User Snapshot Success',
  getUserSnapshotFailure: '[Face Detection] Get User Snapshot Failure',
};

export const compareFace = createAction(
  faceDetectionActions.compareFace,
  props<{ participantId: string; base64Image: string }>(),
);

export const compareFaceSuccess = createAction(
  faceDetectionActions.compareFaceSuccess,
  props<{ result: FaceDetectionResponse }>(),
);

export const compareFaceFailure = createAction(
  faceDetectionActions.compareFaceFailure,
  props<{ error: string }>(),
);

export const getUserSnapshot = createAction(
  faceDetectionActions.getUserSnapshot,
);

export const getUserSnapshotSuccess = createAction(
  faceDetectionActions.getUserSnapshotSuccess,
  props<{ result: GetSnapshotResponse }>(),
);

export const getUserSnapshotFailure = createAction(
  faceDetectionActions.getUserSnapshotFailure,
  props<{ error: string }>(),
);
